import React from 'react';

const STORY_BLOCKS = [
  {
    year: 'THE VISION',
    title: 'Why I Built Korsha',
    desc: 'I wanted to create a studio that takes ideas from zero to live — without the overhead of large agencies. Fast, quality-driven, and deeply technical.',
  },
  {
    year: 'APPROACH',
    title: 'End-to-End Ownership',
    desc: 'Every project I take on gets the full treatment — wireframes, design systems, React frontend, Node.js API, database design, cloud deployment, and post-launch support.',
  },
  {
    year: 'NEXT',
    title: 'Your Project Could Be Next',
    desc: 'Have an idea that needs a technical co-founder mindset? Let\'s brainstorm, plan, and build it together — from first principles to production.',
  },
];

const VALUES = [
  { icon: '🔥', title: 'Move Fast', desc: 'Ship, iterate, and learn — no analysis paralysis.' },
  { icon: '💎', title: 'Quality First', desc: 'Every line of code, every pixel — crafted with care.' },
  { icon: '🌐', title: 'Full Ownership', desc: 'End-to-end accountability for every project.' },
  { icon: '🤝', title: 'True Partnership', desc: 'I work with you, not just for you — co-founder mindset.' },
];

const Team = () => (
  <section id="team">
    <div className="container">
      <span className="section-tag">The Founder</span>
      <h2 className="section-title">
        THE MIND<br />
        <span className="gradient-text">BEHIND KORSHA</span>
      </h2>
      <div className="glow-line" />
      <p className="section-subtitle" style={{ marginBottom: '56px' }}>
        One vision, one architect, relentless execution.
        Korsha is designed, built, and shipped by a single force of nature.
      </p>

      <div className="solo-founder">
        {/* Founder Card */}
        <div className="glass-card founder-card">
          <div className="founder-card-top">
            <div className="founder-bg-glow" />
            <div className="founder-avatar">
              SN
              <div className="founder-avatar-ring" />
              <div className="founder-avatar-ring2" />
            </div>
          </div>
          <div className="founder-card-body">
            <div className="founder-name">Suresh Narasimman</div>
            <div className="founder-role">Founder · Senior UI Developer · 9+ Years</div>
            <p className="founder-bio">
              Building full-stack products end-to-end — from pixel-perfect React UIs to
              robust Node.js backends. I architect, design, develop, and deploy. No middleman.
            </p>
            <div className="founder-tags">
              {['React / Next.js', 'Node.js', 'TypeScript', 'UI/UX', 'Cloud'].map(tag => (
                <span key={tag} className="founder-tag">{tag}</span>
              ))}
            </div>
            <a href="mailto:sureshsimmar@gmail.com" className="founder-email">
              ✉ sureshsimmar@gmail.com
            </a>
          </div>
        </div>

        {/* Journey Blocks */}
        <div className="founder-story">
          {STORY_BLOCKS.map(({ year, title, desc }) => (
            <div key={year} className="story-block">
              <div className="story-year">{year}</div>
              <div className="story-title">{title}</div>
              <p className="story-desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Values */}
      <div className="values-grid">
        {VALUES.map(({ icon, title, desc }) => (
          <div key={title} className="glass-card value-card">
            <span className="value-icon">{icon}</span>
            <div className="value-title">{title}</div>
            <div className="value-desc">{desc}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Team;
